// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__359p2","vLegacy":"SelectSecondary_vLegacy__3pXUd","error":"SelectSecondary_error__1Moni","disabled":"SelectSecondary_disabled__LaFp_"};